/**
 * main.tsx
 *
 * NE İŞE YARAR : Arayüzün giriş noktası — tema ve sağlayıcılar burada bağlanır
 * KAYNAK SPEC  : 15-arayuz-standardi.md §3 (teknoloji) · §4.5 (koyu tema kapalı)
 *                §12 (tarih ve saat) · §14 (dil)
 * BAĞLI OLDUĞU : react-dom · @mantine/core · src/tema/tema.ts · src/uygulama.tsx
 * KULLANAN     : index.html
 * DİKKAT       : 1) KOYU TEMA FAZ 1'DE KAPALI (`15` §4.5) ve `forceColorScheme` ile
 *                   **açıkça** kapatılıyor. Varsayılana bırakılsaydı, işletim sistemi
 *                   koyu temadaysa kullanıcı hiç gözden geçirilmemiş bir arayüz görürdü.
 *                   Altyapı hazır; kapatan tek satır budur.
 *                2) SAAT DİLİMİ `Europe/Istanbul`DUR (`15` §12, `04` §2.4). Tarayıcının
 *                   yerel saatine bırakılsaydı, yurt dışındaki bir kullanıcı yerleşim
 *                   tarihlerini kaydırılmış görür ve *"dün başladı"* diye okurdu.
 *                3) BİLDİRİMLER TEK YERDEN GEÇER (`15` §9). Her ekranın kendi bildirim
 *                   düzeneğini kurması, aynı olayın iki farklı biçimde görünmesine yol
 *                   açardı.
 *                4) `StrictMode` AÇIK: geliştirmede etkileri iki kez çalıştırır ve yan
 *                   etkisi olan bir bileşen bunu **hemen** belli eder. Kapatmak, hatayı
 *                   üretime ertelemekten başka bir şey yapmaz.
 *                5) YOL SAĞLAYICISI BİLDİRİMLERİ DE KAPSAR (`15` §9). Bir bildirim
 *                   içinde uygulama içi bağlantı bulunabiliyor — cihaz sınırı uyarısı
 *                   cihaz listesine bağlanıyor (`15` §15.1). Bildirimler yol
 *                   sağlayıcısının dışında kalsaydı o bağlantı çalışmaz, tam sayfa
 *                   yenileme yapmak zorunda kalırdı.
 * SON GÜNCELLEME: 2026-08-31 04:40:00
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { DatesProvider } from '@mantine/dates';
import { BrowserRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/tr';

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';

import { UYGULAMA_ADI } from './marka';
import { tema } from './tema/tema';
import { Uygulama } from './uygulama';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('tr');
dayjs.tz.setDefault('Europe/Istanbul');

const kok = document.getElementById('kok');
if (kok === null) {
  // Sessizce hiçbir şey çizmemek yerine patlar: boş bir sayfanın sebebi aranırken
  // en son bakılan yer bu dosya olurdu.
  throw new Error('Kök öğe bulunamadı — index.html değişmiş olabilir.');
}

// Sekme başlığı marka dosyasından yazılır (`marka.ts` notu 2). `index.html`teki değer
// yalnız JavaScript yüklenene kadar görünen yedektir.
document.title = UYGULAMA_ADI;

createRoot(kok).render(
  <StrictMode>
    <MantineProvider theme={tema} forceColorScheme="light">
      {/*
        Saat dilimi `DatesProvider`ın ayarı DEĞİLDİR — Mantine 8'de o ayar kaldırıldı ve
        dönüşüm `dayjs.tz.setDefault` ile yapılıyor (yukarıda). Tarih seçici yalnız yerel
        ve haftanın ilk gününü bilir; gerçek dönüşüm dayjs'in işidir.
      */}
      <DatesProvider settings={{ locale: 'tr', firstDayOfWeek: 1 }}>
        {/* Bildirimler yol sağlayıcısının İÇİNDEDİR (başlıktaki not 5). */}
        <BrowserRouter>
          <Notifications position="top-right" limit={3} />
          <Uygulama />
        </BrowserRouter>
      </DatesProvider>
    </MantineProvider>
  </StrictMode>,
);
